import React from "react";
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Support = () => {
  return (
    <MDBox className="support-container">
      <MDTypography variant="h4" className="text-center">
        Support Page
      </MDTypography>

      {/* Support Introduction */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h5">1. Support Introduction</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <MDTypography>
            Welcome to the LBIC Support Page. Here, you can find help for any issues you encounter while using our services.
          </MDTypography>
        </AccordionDetails>
      </Accordion>

      {/* Contact Support */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h5">2. Contact Support</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <MDTypography>Email: support@lbic.com</MDTypography>
          <MDTypography>Phone: +123-456-7890</MDTypography>
          <MDTypography>Live Chat: Available on our website</MDTypography>
        </AccordionDetails>
      </Accordion>

      {/* FAQs */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h5">3. FAQs (Frequently Asked Questions)</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>How to create an account?</li>
            <li>How to reset a password?</li>
            <li>How to report a problem?</li>
            <li>How to get technical assistance?</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      {/* Troubleshooting Guides */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h5">4. Troubleshooting Guides</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <MDTypography>
            Find solutions to common issues and step-by-step guides for common tasks.
          </MDTypography>
        </AccordionDetails>
      </Accordion>

      {/* Help Articles & Documentation */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h5">5. Help Articles & Documentation</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <MDTypography>
            Access tutorials, guides, and detailed instructions for using LBIC services.
          </MDTypography>
        </AccordionDetails>
      </Accordion>

      {/* Community & Feedback */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h5">6. Community & Feedback</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <MDTypography>
            Join our forums or discussion groups to connect with other users. Share your feedback using our feedback form.
          </MDTypography>
        </AccordionDetails>
      </Accordion>
    </MDBox>
  );
};

export default Support;
